// NavBarScroll
var prevScrollpos = window.scrollY;

window.onload = function() {
  var navbarScroller = document.getElementById("navbar_scroll_hide")

  if (navbarScroller != undefined) {
    // var otherSect = document.getElementById("navbar-resizer")

    window.onscroll = function() {
      var currentScrollPos = window.scrollY;
      if (prevScrollpos > currentScrollPos) {
        navbarScroller.classList.add("top-0");
        navbarScroller.classList.remove("-top-16");
        // otherSect.classList.add("mt-16");
        // otherSect.classList.remove("mt-0");
      } else {
        navbarScroller.classList.remove("top-0");
        navbarScroller.classList.add("-top-16");
        // otherSect.classList.add("mt-0");
        // otherSect.classList.remove("mt-16");
      }
      prevScrollpos = currentScrollPos;
    }
  }
}
